module.exports = __webpack_public_path__ + "img/aprueba-entrevista.c64d5e04.png";